import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { ScrollProvider, ScrollConsumer } from '@stickyroll/context';
import { Tracker } from '@stickyroll/tracker';
import { hashCode, classNames } from '@stickyroll/utils';
var version = "1.1.6";
/**
 * Styles for the core frame
 */

var styles = {
  overlay: "\n\t\theight: 100vh;\n\t\tposition: -webkit-sticky;\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t",
  skip: "\n\t\tposition: absolute; \n\t\ttop: 100%;\n\t",
  target: "\n\t\tdisplay: block; \n\t\theight: 100vh;\n\t",
  targets: "\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t",
  wrapper: "\n\t\tposition: relative;\n\t\tmargin: 0;\n\t"
};
/**
 * Hashed classNames for styling
 */

var hashSelectors = {
  wrapper: hashCode("/* stickyroll-version: ".concat(version, " */\n").concat(styles.wrapper)),
  overlay: hashCode("/* stickyroll-version: ".concat(version, " */\n").concat(styles.overlay)),
  targets: hashCode("/* stickyroll-version: ".concat(version, " */\n").concat(styles.targets)),
  target: hashCode("/* stickyroll-version: ".concat(version, " */\n").concat(styles.target)),
  skip: hashCode("/* stickyroll-version: ".concat(version, " */\n").concat(styles.skip))
};
/**
 * Hashed and prefixed classNames for styling
 * (currently not in use, keep for future scope safety)
 */

var hashNSSelectors = {
  wrapper: "sr-".concat(hashCode(hashSelectors.wrapper)),
  overlay: "sr-".concat(hashCode(hashSelectors.overlay)),
  targets: "sr-".concat(hashCode(hashSelectors.targets)),
  target: "sr-".concat(hashCode(hashSelectors.target)),
  skip: "sr-".concat(hashCode(hashSelectors.skip))
};
/**
 * Hashed and hash-prefixed classNames combined
 */

var hashClassNames = {
  wrapper: classNames(hashNSSelectors.wrapper, hashSelectors.wrapper),
  overlay: classNames(hashNSSelectors.overlay, hashSelectors.overlay),
  targets: classNames(hashNSSelectors.targets, hashSelectors.targets),
  target: classNames(hashNSSelectors.target, hashSelectors.target),
  skip: classNames(hashNSSelectors.skip, hashSelectors.skip)
};
/**
 * Core styling required to display the component correctly
 */

var CORE_STYLE = "\n\tbody {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 0;\n\t}\n\t.".concat(hashSelectors.wrapper, "{").concat(styles.wrapper, "}\n\t.").concat(hashSelectors.overlay, "{").concat(styles.overlay, "}\n\t.").concat(hashSelectors.targets, "{").concat(styles.targets, "}\n\t.").concat(hashSelectors.target, "{").concat(styles.target, "}\n\t.").concat(hashSelectors.skip, "{").concat(styles.skip, "}\n\t.").concat(hashSelectors.wrapper, "{").concat(styles.wrapper, "}\n").replace(/\s+/g, "").replace(/;}/g, "}");
/**
 * The style tag needed to display the component correctly
 */

var CORE_STYLE_TAG = "<style data-stickyroll data-stickyroll-version=\"".concat(version, "\">").concat(CORE_STYLE, "</style>");
/**
 * Injects core styles for Stickyroll. This is the client side version.
 * Stickyroll will inject these styles to ensure the correct behavior.
 * @constructor
 */

var INJECT_CORE_STYLE = function INJECT_CORE_STYLE() {
  var existingStyle = document.head.querySelector("[data-stickyroll]");

  if (Boolean(existingStyle)) {
    var styleVersion = existingStyle.getAttribute("data-stickyroll-version");

    if (styleVersion === version) {
      document.head.appendChild(existingStyle);
      return;
    }
  }

  var style = document.createElement("style");
  style.setAttribute("data-stickyroll", "");
  style.setAttribute("data-stickyroll-version", "".concat(version));
  style.innerHTML = CORE_STYLE;
  document.head.appendChild(style);
};

var Frame = /*#__PURE__*/function (_React$Component) {
  _inherits(Frame, _React$Component);

  var _super = _createSuper(Frame);

  function Frame() {
    var _this;

    _classCallCheck(this, Frame);

    _this = _super.apply(this, arguments);
    /**
     * @public
     * @type {IFrameState}
     */

    _this.state = {
      page: 0,
      scrollOffset: 0,
      scrollY: 0
    };
    /**
     * @private
     * @type {React.RefObject<HTMLDivElement>}
     */

    _this.tracker = React.createRef();
    /**
     * A Wrapper around the content to ensure the correct behavior during interaction.
     * Renders a sticky container, an event-tracker and optionally anchor targets to allow deep-links.
     * @constructor
     * @private
     * @type {React.FunctionComponent}
     * @param props
     * @return {ReactElement<any> | null}
     */

    _this.Wrapper = function (_ref) {
      var children = _ref.children;
      return React.createElement(React.Fragment, null, React.createElement(Tracker, {
        onUpdate: _this.handleUpdate,
        throttle: _this.props.throttle
      }), React.createElement("div", {
        className: classNames(hashClassNames.wrapper, _this.props.className),
        ref: _this.tracker,
        style: _this.wrapperStyle
      }, _this.anchors, React.createElement("div", {
        className: hashClassNames.overlay
      }, children)));
    };
    /* istanbul ignore next */

    /**
     * Scroll handler to parse the page and progress from the scroll position.
     * @private
     * @param {number} scrollY
     * @returns {void}
     */


    _this.handleUpdate = function (scrollY) {
      if (!_this.tracker || !_this.tracker.current) {
        return;
      }

      var page = 0;
      var scrollOffset = 0;

      var _this$tracker$current = _this.tracker.current.getBoundingClientRect(),
          top = _this$tracker$current.top,
          bottom = _this$tracker$current.bottom;

      var factor = _this.props.factor;
      var _window = window,
          _window$innerHeight = _window.innerHeight,
          innerHeight = _window$innerHeight === void 0 ? 0 : _window$innerHeight;
      var touchedTop = top <= 0;
      var touchedEnd = bottom <= innerHeight;

      if (touchedTop && !touchedEnd) {
        page = Math.max(0, Math.min(_this.pageCount - 1, Math.floor(top * (-1 / factor) / innerHeight)));
        scrollOffset = Math.max(0, Math.min(1, top * -1 % (innerHeight * factor) / innerHeight / factor));
      } else if (touchedEnd) {
        page = _this.pageCount - 1;
        scrollOffset = 1;
      }

      _this.setState({
        page: page,
        scrollOffset: scrollOffset,
        scrollY: scrollY
      });
    };

    return _this;
  }
  /**
   * @public
   * @type {IFrameDefaultProps}
   */


  _createClass(Frame, [{
    key: "componentDidMount",
    value:
    /**
     * Write the current scrollPosition to the internal state when the component is mounted.
     * This will allow getting the correct page and progress after mounting.
     * @public
     */
    function componentDidMount() {
      Frame.injectStyle();
      this.setState({
        scrollY: window.scrollY
      });
    }
    /* istanbul ignore next */

    /**
     * Call the onPage handler if it is defined every time the page changes.
     * No initial call!
     * @public
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      var _this$state = this.state,
          page = _this$state.page,
          scrollOffset = _this$state.scrollOffset;

      if (oldState.page !== page) {
        this.props.onPage && this.props.onPage(this.state.page);
      }

      if (oldState.scrollOffset !== scrollOffset) {
        var zero = scrollOffset === 0;
        var one = scrollOffset === 1;
        var start = zero && page === 0;
        var end = one && page === this.pageCount - 1;

        if (start && this.props.onStart) {
          this.props.onStart();
        } else if (end && this.props.onEnd) {
          this.props.onEnd();
        }
      }
    }
    /**
     * Rendering can be configured in two different ways.
     * 1. Using `children`:
     *    * uses context
     *    * supports context based plugins
     * 2. Using `render`:
     *    * better performance
     *
     * The differences are based on the use of context. To allow context based plugins it is advised
     * to use a child function. To improve performance the render property can be used (Plugins can still be used but
     * must be configured manually)
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          children = _this$props.children,
          anchors = _this$props.anchors; // Test for either the render property or children to be defined as function.
      // Render wins over children if both are defined. If neither is defined as function, a TypeError is thrown.

      if (typeof render !== "function" && typeof children !== "function") {
        throw new TypeError("Either children or render needs to be defined as a function");
      }

      var page = this.state.page;
      var Wrapper = this.Wrapper; // Convert the scrollOffset from percent to a timeline [0,1]

      var progress = this.state.scrollOffset; // const {innerHeight} = window;
      // const clippedProgress = Math.round(progress * innerHeight) / innerHeight;
      // Switch between context free and context based versions

      switch (typeof render) {
        case "function":
          // Context free
          return React.createElement(Wrapper, null, render({
            anchors: anchors,
            page: page + 1,
            pageIndex: page,
            pages: this.pageCount,
            progress: progress
          }));
        // Context based

        default:
          return React.createElement(ScrollProvider, {
            value: {
              anchors: anchors,
              page: page + 1,
              pageIndex: page,
              pages: this.pageCount,
              progress: progress
            }
          }, React.createElement(Wrapper, null, React.createElement(ScrollConsumer, null, children)));
      }
    }
  }, {
    key: "pageCount",
    get: function get() {
      var pages = this.props.pages;
      return Array.isArray(pages) ? pages.length : pages;
    }
    /**
     * @type {React.CSSProperties}
     */

  }, {
    key: "wrapperStyle",
    get: function get() {
      var factor = this.props.factor;
      var vh = this.pageCount * 100 * factor + 100;
      return {
        height: "".concat(vh, "vh")
      };
    }
    /**
     * If anchors are defined, a collection of spans with the correct IDs are provided.
     * This allows to link or jump to a section or even skip the entire content.
     * @type {React.ReactElement<HTMLDivElement> | null}
     */

  }, {
    key: "anchors",
    get: function get() {
      var anchors = this.props.anchors;

      if (!(typeof anchors === "string")) {
        return null;
      }

      var factor = this.props.factor;
      var glue = anchors.length ? "/" : "";
      var targets = Array(this.pageCount).fill(Boolean).map(function (x, i) {
        return React.createElement("span", {
          id: "".concat(anchors).concat(glue).concat(i + 1),
          key: "".concat(anchors, ":").concat(i + 1),
          className: hashClassNames.target,
          style: {
            height: "".concat(100 * factor, "vh")
          }
        });
      });
      return React.createElement("div", {
        className: hashClassNames.targets
      }, targets, React.createElement("span", {
        id: "".concat(anchors).concat(glue).concat(this.pageCount + 1),
        className: hashClassNames.target
      }), React.createElement("span", {
        id: "".concat(anchors).concat(glue, "skip"),
        className: hashClassNames.skip
      }));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        factor: 1
      };
    }
  }, {
    key: "injectStyle",
    value: function injectStyle() {
      INJECT_CORE_STYLE();
    }
  }, {
    key: "getStyleTag",
    value: function getStyleTag() {
      return CORE_STYLE_TAG;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return CORE_STYLE;
    }
  }]);

  return Frame;
}(React.Component);

export { CORE_STYLE, CORE_STYLE_TAG, Frame, hashClassNames };